// JOBE-0044.4: GroupDivider — JetBrains Mono uppercase date-relative
// divider interleaved into the list at each `groupLabel` transition.
// No sticky positioning in v1 — "sticky-feeling" per umbrella §R2 is
// a visual treatment for JOBE-0044.7, not a layout invariant here.

export function GroupDivider({ label }) {
  return (
    <li className="library-group-divider" role="presentation">
      <span className="library-group-divider-label">{label}</span>
    </li>
  );
}
